import {
    SET_STOCKS,
    LOADING_STOCKS,
    LOADING_SCORES,
    SET_SCORES,
    LOADING_OTHER_USER_STOCKS,
    SET_OTHER_USER_STOCKS,
} from '../types';
import axios from 'axios';
import { sort, filterStocks } from '../../helpers/filterFunctions';

//gets all stocks and updates  data
export const getStocks = (currProps, filterArr) => async (dispatch) => {
    if (currProps.loading) return;

    if (currProps.leaderboard && currProps.leaderboard.length !== 0) {
        const payloadData = {
            ...currProps,
            stocks: sort(
                filterStocks(currProps.stocks, filterArr),
                'seed',
                'asc'
            ),
            filters: filterArr,
        };
        dispatch({
            type: SET_STOCKS,
            payload: payloadData,
        });
        return;
    }

    console.time('getting stocks');

    console.log('Fetching stocks');

    dispatch({ type: LOADING_STOCKS });

    let leaderboardData = [];
    let stocksData = [];

    await Promise.all([
        axios.get('/leaderboard').then((res) => {
            if (res) {
                leaderboardData = res.data.map((stock) => ({ ...stock }));
            }
        }),
        axios.get('/stocks').then((res) => {
            stocksData = sort(filterStocks(res.data, filterArr), 'seed', 'asc');
        }),
    ])
        .then(() => {
            console.timeEnd('getting stocks');
            console.time('dispatch');
            const payloadData = {
                ...currProps,
                leaderboard: leaderboardData,
                stocks: stocksData,
                filters: filterArr,
                currStock: {
                    trades: [],
                    stockHistory: [],
                    stockData: {
                        price: null,
                    },
                },
                trades: [],
            };
            dispatch({
                type: SET_STOCKS,
                payload: payloadData,
            });
            console.timeEnd('dispatch');
        })
        .catch((err) => {
            dispatch({
                type: SET_STOCKS,
                payload: [],
            });
        });
};

//gets all stocks and updates  data
export const getScores = (currProps, filterArr) => async (dispatch) => {
    if (currProps.loading) return;

    if (currProps.scores && currProps.scores.length !== 0) {
        return;
    }

    dispatch({ type: LOADING_SCORES });

    console.log('Fetching scores');

    await axios
        .get('/scores')
        .then((res) => {
            const payloadData = {
                ...currProps,
                scores: res.data,
            };
            console.log('SCORES FORMAT', res.data);

            dispatch({
                type: SET_SCORES,
                payload: payloadData,
            });
        })
        .catch((err) => {
            dispatch({
                type: SET_SCORES,
                payload: {
                    scores: [],
                    loading: false,
                },
            });
        });
};

//gets all stocks and updates  data
export const getOtherUserStocks = (userId) => async (dispatch) => {
    dispatch({ type: LOADING_OTHER_USER_STOCKS });
    let payloadData = {};
    userId = userId.replace("'", '’');
    console.log('Fetching other user stocks');
    await axios
        .get(`/userStocks/${userId}`)
        .then((res) => {
            payloadData.stocks = res.data.sort((a, b) => {
                if (!a.currPoints) {
                    a.currPoints = 0;
                }
                if (!b.currPoints) {
                    b.currPoints = 0;
                }

                if (
                    b.currPoints * b.numShares - a.currPoints * a.numShares !==
                    0
                ) {
                    return (
                        b.currPoints * b.numShares - a.currPoints * a.numShares
                    );
                } else {
                    return b.numShares - a.numShares;
                }
            });
            dispatch({
                type: SET_OTHER_USER_STOCKS,
                payload: payloadData,
            });
        })
        .catch((err) => {
            dispatch({
                type: SET_OTHER_USER_STOCKS,
                payload: {
                    scores: [],
                },
            });
        });
};

//gets single stock info and stores it in currStock
export const getCurrStock =
    (currProps, filterArr, stockId) => async (dispatch) => {
        if (currProps.loading) return;

        let fetchedStock = undefined;
        if (currProps.stocks) {
            fetchedStock = currProps.stocks.find((stock) => {
                return stock.stockId === stockId;
            });
        }

        let stockData = null;
        if (fetchedStock) {
            stockData = fetchedStock;
        } else {
            dispatch({ type: LOADING_STOCKS });
            console.log('Fetching curr stock data');
            await axios.get(`/stocks/${stockId}`).then((res) => {
                stockData = res.data;
            });
        }

        const payloadData = {
            ...currProps,
            currStock: {
                ...currProps.currStock,
                stockData: stockData,
            },
        };

        dispatch({
            type: SET_STOCKS,
            payload: payloadData,
        });
    };

//sets stocks with updated filters
export const setStocks = (currProps, filterArr) => (dispatch) => {
    if (currProps.loading) return;

    dispatch({ type: LOADING_STOCKS });
    const payloadData = {
        ...currProps,
        stocks: filterStocks(currProps.stocks, filterArr),
        filters: filterArr,
    };
    dispatch({
        type: SET_STOCKS,
        payload: payloadData,
    });
};

//sorts and updates all stocks
export const sortCurrStocks =
    (currProps, orderBy, dir, watchlist) => (dispatch) => {
        if (currProps.loading) return;

        dispatch({ type: LOADING_STOCKS });
        const payloadData = {
            ...currProps,
            stocks: sort(currProps.stocks, orderBy, dir, watchlist),
        };
        dispatch({
            type: SET_STOCKS,
            payload: payloadData,
        });
    };
